"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TITLE_COLOR = void 0;
var TRANSLATION = {
  priorityBaggageTitle: 'Add Priority Baggage',
  priorityBaggageNote: 'Save time with our priority handling as your checked baggage will be on of the first to arrive.',
  priorityBaggageUnit: 'per person',
  departureFlight: 'Departure flight',
  returnFlight: 'Return flight',
  add: 'Add',
  added: 'Added'
};
exports.TRANSLATION = TRANSLATION;
var TITLE_COLOR = 'blue';
exports.TITLE_COLOR = TITLE_COLOR;